import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "full-container" }
const _hoisted_2 = { class: "header-menu-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex1" }, null, -1)
const _hoisted_4 = { class: "body-container" }
const _hoisted_5 = { class: "vertical-menu-container" }
const _hoisted_6 = { class: "flex1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_list = _resolveComponent("select-list")
  const _component_text_popover = _resolveComponent("text-popover")
  const _component_horizontal = _resolveComponent("horizontal")
  const _component_vertical = _resolveComponent("vertical")
  const _component_router_view = _resolveComponent("router-view")
  const _component_password_dialog = _resolveComponent("password-dialog")
  const _component_set_time_zone_dialog = _resolveComponent("set-time-zone-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_horizontal, {
      onLogOut: _ctx.goBackLogin,
      "home-url": `/${_ctx.superBaseRouter}/${_ctx.superSubRouter.personalDevice}`
    }, {
      default: _withCtx(() => [
        _createVNode("header", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_text_popover, {
            name: "supermanage",
            isShow: _ctx.controlPopVal['opera'],
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideOtherPop(Boolean($event), 'opera')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_select_list, {
                list: _ctx.userOperaList,
                onChangeSelect: _ctx.chooseOpera
              }, null, 8, ["list", "onChangeSelect"])
            ]),
            _: 1
          }, 8, ["isShow"])
        ])
      ]),
      _: 1
    }, 8, ["onLogOut", "home-url"]),
    _createVNode("section", _hoisted_4, [
      _createVNode("aside", _hoisted_5, [
        _createVNode(_component_vertical, { menus: _ctx.menus }, null, 8, ["menus"])
      ]),
      _createVNode("section", _hoisted_6, [
        _createVNode(_component_router_view, {
          key: _ctx.$route.fullPath
        })
      ])
    ]),
    (_ctx.isShowPasswordDialog)
      ? (_openBlock(), _createBlock(_component_password_dialog, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowPasswordDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowTimeZoneDialog)
      ? (_openBlock(), _createBlock(_component_set_time_zone_dialog, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowTimeZoneDialog = false))
        }))
      : _createCommentVNode("", true)
  ]))
}